<template>
	<div class="main-content" v-if="detailList">
		<div class="header">
			<div class="container-fluid">
				<div class="mt-5">
					<div class="card">
						<div class="card-body">
							<nav aria-label="breadcrumb">
								<ol class="breadcrumb">
									<li class="breadcrumb-item fw-bolder">
										<router-link :to="{ name: 'ListContract' }" style="color: black"> List Contract </router-link>
									</li>
									<li class="breadcrumb-item">Detail Contract</li>
								</ol>
							</nav>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="container-fluid">
			<div class="header">
				<div class="mt-5">
					<div class="card">
						<div class="card-header">
							<h3 class="card-header-title">
								Details Contract -
								<span v-if="detailList.status == 'Early Termination'" :class="getStatusClass(detailList.status)">
									Early Terminated
								</span>
								<span v-if="detailList.status == 'Closed'" :class="getStatusClass(detailList.status)"> Closed </span>
								<span v-if="detailList.status == 'On Going'" :class="getStatusClass(detailList.status)"> On Going </span>
								<span v-if="detailList.status == 'Expired Soon'" :class="getStatusClass(detailList.status)">
									Expired Soon
								</span>
								<span v-if="detailList.status == 'Expired'" :class="getStatusClass(detailList.status)"> Expired </span>
								<span v-if="detailList.status == 'Draft'" :class="getStatusClass(detailList.status)"> Draft </span>
								<span v-if="detailList.value_warning" :class="'ml-2 ' + getStatusClass('Value Warning')"> Value Warning </span>
							</h3>

							<div class="text-center">
								<div
									class="row mb-4"
									v-if="detailList.status !== 'Closed' && detailList.status !== 'Early Termination' && this.canEdit"
								>
									<div class="col">
										<button @click="bodyClosed('Closed')" class="mt-4 btn btn-secondary mr-3" type="button">
											Close Contract
										</button>
										<button class="mt-4 btn btn-primary" type="button" @click="bodyClosed('Early Termination')">
											Early Termination
										</button>
									</div>
								</div>
							</div>
							<!-- <b-dropdown variant="primary">
                <template #button-content>
                  <span class="fe fe-download"></span>
                </template>
<b-dropdown-item v-if="
                    detailList.status == 'Closed' ||
                    detailList.status == 'Early Termination'
                  " @click="downloadData(detailList.id, detailList.name)">Excel</b-dropdown-item>
<b-dropdown-item @click="downloadItem(detailList.files[0])">File</b-dropdown-item>
</b-dropdown> -->
						</div>
						<div class="row card-body">
							<div class="px-2">
								<div class="row gx-3 gy-3">
									<div class="col-12 col-lg-6">
										<div class="card p-3">
											<div class="row gx-3 gy-5">
												<div class="col-12 col-lg-6">
													<div class="row align-items-center">
														<div class="col-auto">
															<div class="avatar avatar-sm">
																<div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
																	<i class="fe fe-clipboard"></i>
																</div>
															</div>
														</div>
														<div class="col ms-n2">
															<h4 class="mb-1 font-weight-bold">Type of Contract</h4>
															<small class="text-body-secondary"
																><span> {{ detailList.typeContract?.name }}<br /></span
															></small>
														</div>
													</div>
												</div>
												<div class="col-12 col-lg-6">
													<div class="row align-items-center">
														<div class="col-auto">
															<div class="avatar avatar-sm">
																<div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
																	<i class="fe fe-bookmark"></i>
																</div>
															</div>
														</div>
														<div class="col ms-n2">
															<h4 class="mb-1 font-weight-bold">Contract Name</h4>
															<small class="text-body-secondary"
																><span> {{ detailList?.name }}<br /></span
															></small>
														</div>
													</div>
												</div>
												<div class="col-12 col-lg-6">
													<div class="row align-items-center">
														<div class="col-auto">
															<div class="avatar avatar-sm">
																<div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
																	<i class="fe fe-bookmark"></i>
																</div>
															</div>
														</div>
														<div class="col ms-n2">
															<h4 class="mb-1 font-weight-bold">Contract Number</h4>
															<small class="text-body-secondary"
																><span> {{ detailList.no }}<br /></span
															></small>
														</div>
													</div>
												</div>
												<div class="col-12 col-lg-6">
													<div class="row align-items-center">
														<div class="col-auto">
															<div class="avatar avatar-sm">
																<div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
																	<i class="fe fe-dollar-sign"></i>
																</div>
															</div>
														</div>
														<div class="col ms-n2">
															<h4 class="mb-1 font-weight-bold">Contract Value</h4>
															<small class="text-body-secondary"
																><span> Rp.{{ convertNumber(detailList.contract_value) }}<br /></span
															></small>
														</div>
													</div>
												</div>
												<div class="col-12 col-lg-6">
													<div class="row align-items-center">
														<div class="col-auto">
															<div class="avatar avatar-sm">
																<div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
																	<i class="fe fe-dollar-sign"></i>
																</div>
															</div>
														</div>
														<div class="col ms-n2">
															<h4 class="mb-1 font-weight-bold">Remaining Value</h4>
															<small class="text-body-secondary">
																<span>
																	{{ detailList.remaining_budget ? `Rp.${convertNumber(detailList.remaining_budget)}` : '-' }}<br />
																</span>
															</small>
														</div>
													</div>
												</div>
												<div class="col-12 col-lg-6">
													<div class="row align-items-center">
														<div class="col-auto">
															<div class="avatar avatar-sm">
																<div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
																	<i class="fe fe-home"></i>
																</div>
															</div>
														</div>
														<div class="col ms-n2">
															<h4 class="mb-1 font-weight-bold">Vendor</h4>
															<small class="text-body-secondary"
																><span> {{ detailList.vendor }}<br /></span
															></small>
														</div>
													</div>
												</div>
												<div class="col-12 col-lg-6">
													<div class="row align-items-center">
														<div class="col-auto">
															<div class="avatar avatar-sm">
																<div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
																	<i class="fe fe-user"></i>
																</div>
															</div>
														</div>
														<div class="col ms-n2">
															<h4 class="mb-1 font-weight-bold">Contract Owner</h4>
															<small class="text-body-secondary"
																><span> {{ detailList.owner?.fullname }}<br /></span
															></small>
														</div>
													</div>
												</div>
												<div class="col-12 col-lg-6">
													<div class="row align-items-center">
														<div class="col-auto">
															<div class="avatar avatar-sm">
																<div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
																	<i class="fe fe-octagon"></i>
																</div>
															</div>
														</div>
														<div class="col ms-n2">
															<h4 class="mb-1 font-weight-bold">Contract Owner Department</h4>
															<small class="text-body-secondary"
																><span> {{ ownerDepartment }}<br /></span
															></small>
														</div>
													</div>
												</div>
												<div class="col-12 col-lg-6">
													<div class="row align-items-center">
														<div class="col-auto">
															<div class="avatar avatar-sm">
																<div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
																	<i class="fe fe-user"></i>
																</div>
															</div>
														</div>
														<div class="col ms-n2">
															<h4 class="mb-1 font-weight-bold">Contract Co-Owner/PMO</h4>
															<small class="text-body-secondary"
																><span> {{ detailList.co_owner?.fullname }}<br /></span
															></small>
														</div>
													</div>
												</div>
												<div class="col-12 col-lg-6">
													<div class="row align-items-center">
														<div class="col-auto">
															<div class="avatar avatar-sm">
																<div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
																	<i class="fe fe-octagon"></i>
																</div>
															</div>
														</div>
														<div class="col ms-n2">
															<h4 class="mb-1 font-weight-bold">Contract Co-Owner/PMO Department</h4>
															<small class="text-body-secondary"
																><span> {{ coOwnerDepartment }}<br /></span
															></small>
														</div>
													</div>
												</div>
												<div class="col-12 col-lg-6">
													<div class="row align-items-center">
														<div class="col-auto">
															<div class="avatar avatar-sm">
																<div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
																	<i class="fe fe-calendar"></i>
																</div>
															</div>
														</div>
														<div class="col ms-n2">
															<h4 class="mb-1 font-weight-bold">Start Date</h4>
															<small class="text-body-secondary"
																><span> {{ startDate }}<br /></span
															></small>
														</div>
													</div>
												</div>
												<div class="col-12 col-lg-6">
													<div class="row align-items-center">
														<div class="col-auto">
															<div class="avatar avatar-sm">
																<div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
																	<i class="fe fe-calendar"></i>
																</div>
															</div>
														</div>
														<div class="col ms-n2">
															<h4 class="mb-1 font-weight-bold">End Date</h4>
															<small class="text-body-secondary"
																><span> {{ endDate }}<br /></span
															></small>
														</div>
													</div>
												</div>
												<div class="col-12 col-lg-6">
													<div class="row align-items-center">
														<div class="col-auto">
															<div class="avatar avatar-sm">
																<div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
																	<i class="fe fe-calendar"></i>
																</div>
															</div>
														</div>
														<div class="col ms-n2">
															<h4 class="mb-1 font-weight-bold">Total Duration (Month)</h4>
															<small class="text-body-secondary"
																><span> {{ detailList.total_duration }}<br /></span
															></small>
														</div>
													</div>
												</div>
												<div class="col-12 col-lg-6">
													<div class="row align-items-center">
														<div class="col-auto">
															<div class="avatar avatar-sm">
																<div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
																	<i class="fe fe-star"></i>
																</div>
															</div>
														</div>
														<div class="col ms-n2">
															<h4 class="mb-1 font-weight-bold">Amendment {{ detailList.amandement }}</h4>
															<small class="text-body-secondary"
																><span>Version {{ detailList.version }}<br /></span
															></small>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div class="col-12 col-lg-6">
										<div class="card p-3">
											<div class="row gx-3 gy-5">
												<div class="col-12 col-lg-6">
													<div class="row align-items-center">
														<div class="col-auto">
															<div class="avatar avatar-sm">
																<div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
																	<i class="fe fe-calendar"></i>
																</div>
															</div>
														</div>
														<div class="col ms-n2">
															<h4 class="mb-1 font-weight-bold">Created At</h4>
															<small class="text-body-secondary"
																><span> {{ createdAt }}<br /></span
															></small>
														</div>
													</div>
												</div>
												<div class="col-12 col-lg-6">
													<div class="row align-items-center">
														<div class="col-auto">
															<div class="avatar avatar-sm">
																<div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
																	<i class="fe fe-calendar"></i>
																</div>
															</div>
														</div>
														<div class="col ms-n2">
															<h4 class="mb-1 font-weight-bold">Created By</h4>
															<small class="text-body-secondary"
																><span> {{ createdBy }}<br /></span
															></small>
														</div>
													</div>
												</div>
												<div class="col-12 col-lg-6">
													<div class="row align-items-center">
														<div class="col-auto">
															<div class="avatar avatar-sm">
																<div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
																	<i class="fe fe-calendar"></i>
																</div>
															</div>
														</div>
														<div class="col ms-n2">
															<h4 class="mb-1 font-weight-bold">Last Updated At</h4>
															<small class="text-body-secondary"
																><span> {{ updatedAt }}<br /></span
															></small>
														</div>
													</div>
												</div>
												<div class="col-12 col-lg-6">
													<div class="row align-items-center">
														<div class="col-auto">
															<div class="avatar avatar-sm">
																<div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
																	<i class="fe fe-calendar"></i>
																</div>
															</div>
														</div>
														<div class="col ms-n2">
															<h4 class="mb-1 font-weight-bold">Last Updated By</h4>
															<small class="text-body-secondary"
																><span> {{ updatedBy }}<br /></span
															></small>
														</div>
													</div>
												</div>
												<div class="col-12 col-lg-6">
													<div class="row align-items-center">
														<div class="col-auto">
															<div class="avatar avatar-sm">
																<div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
																	<i class="fe fe-calendar"></i>
																</div>
															</div>
														</div>
														<div class="col ms-n2">
															<h4 class="mb-1 font-weight-bold">Closed At</h4>
															<small class="text-body-secondary"
																><span> {{ closedDate }}<br /></span
															></small>
														</div>
													</div>
												</div>
												<div class="col-12 col-lg-6">
													<div class="row align-items-center">
														<div class="col-auto">
															<div class="avatar avatar-sm">
																<div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
																	<i class="fe fe-calendar"></i>
																</div>
															</div>
														</div>
														<div class="col ms-n2">
															<h4 class="mb-1 font-weight-bold">Closed by</h4>
															<small class="text-body-secondary"
																><span>
																	{{
																		detailList?.activity?.find((x) => x.status === 'Closed')
																			? detailList?.activity?.find((x) => x.status === 'Closed')?.user?.fullname || 'System'
																			: '-'
																	}}
																	<br /></span
															></small>
														</div>
													</div>
												</div>
												<div class="col-12 col-lg-6">
													<div class="row align-items-center">
														<div class="col-auto">
															<div class="avatar avatar-sm">
																<div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
																	<i class="fe fe-calendar"></i>
																</div>
															</div>
														</div>
														<div class="col ms-n2">
															<h4 class="mb-1 font-weight-bold">Terminated At</h4>
															<small class="text-body-secondary"
																><span> {{ terminatedDate }}<br /></span
															></small>
														</div>
													</div>
												</div>
												<div class="col-12 col-lg-6">
													<div class="row align-items-center">
														<div class="col-auto">
															<div class="avatar avatar-sm">
																<div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
																	<i class="fe fe-calendar"></i>
																</div>
															</div>
														</div>
														<div class="col ms-n2">
															<h4 class="mb-1 font-weight-bold">Terminated by</h4>
															<small class="text-body-secondary"
																><span>
																	{{ detailList?.activity?.find((x) => x.status === 'Early Termination')?.user?.fullname || '-' }}
																	<br /></span
															></small>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div class="card p-3">
											<h4 class="mb-3 font-weight-bold">Contract Budget</h4>
											<table class="table table-sm table-striped">
												<thead>
													<tr>
														<th scope="col">Year</th>
														<th scope="col">Is Budget Set ?</th>
													</tr>
												</thead>
												<tbody></tbody>
												<tr v-for="(year, index) in detailList.contractYears" :key="index">
													<td>{{ index }}</td>
													<td>
														<i class="fe fe-check text-success" v-if="detailList.contractYears[index]"></i>
														<i class="fe fe-x text-danger" v-else></i>
													</td>
												</tr>
											</table>
										</div>
									</div>
								</div>
							</div>
							<!-- Questionnaire List -->
							<div class="card">
								<div class="row">
									<div class="row col-12">
										<!-- If self point >= 0 -->
										<template>
											<div class="p-4">
												<div class="col-12 col-xl">
													<h4><strong>Scope Of Work</strong></h4>
													<p class="small mt-2">
														{{ detailList.scope_of_work || 'No scope of work available' }}
													</p>
												</div>
												<!-- <div class="col-12 col-lg-6 col-xl">
                      <h4><strong>Files</strong></h4>
                      <ul>
                        <li><a :href="detailList.files[0].file" target="_blank">{{ detailList.files[0].name }}</a></li>
                      </ul>
                    </div> -->
											</div>
										</template>
									</div>
									<div class="row col-12 col-lg-2 col-sm"></div>
								</div>
							</div>
							<div class="card">
								<div class="card-header">
									<div class="card-header-title">Supporting File</div>
								</div>
								<div class="card-body">
									<div class="row">
										<div class="col-lg-3">
											<div class="form-group">
												<label class="font-weight-bold">ToR</label>
												<p>
													<a :href="detailList.upload_tor?.[0]?.file" target="_blank">{{
														detailList.upload_tor?.[0]?.file ? 'File ToR.pdf' : '-'
													}}</a>
												</p>
											</div>
										</div>
										<div class="col-lg-3">
											<div class="form-group">
												<label class="font-weight-bold">BoQ</label>
												<p>
													<a :href="detailList.upload_boq?.[0]?.file" target="_blank">{{
														detailList.upload_boq?.[0]?.file ? 'File BoQ.pdf' : '-'
													}}</a>
												</p>
											</div>
										</div>
										<div class="col-lg-3">
											<div class="form-group">
												<label class="font-weight-bold">OE</label>
												<p>
													<a :href="detailList.upload_oe?.[0]?.file" target="_blank">{{
														detailList.upload_oe?.[0]?.file ? 'File OE.pdf' : '-'
													}}</a>
												</p>
											</div>
										</div>
										<div class="col-lg-3">
											<div class="form-group">
												<label class="font-weight-bold">NoA/SPP</label>
												<p>
													<a :href="detailList.upload_noa_spp?.[0]?.file" target="_blank">{{
														detailList.upload_noa_spp?.[0]?.file ? 'File NoA/SPP.pdf' : '-'
													}}</a>
												</p>
											</div>
										</div>
										<div class="col-lg-3">
											<div class="form-group">
												<label class="font-weight-bold">Contract Fully Signed</label>
												<p>
													<a :href="detailList.upload_fs?.[0]?.file" target="_blank">{{
														detailList.upload_fs?.[0]?.file ? 'File Contract Fully Signed.pdf' : '-'
													}}</a>
												</p>
											</div>
										</div>
										<div class="col-lg-3">
											<div class="form-group">
												<label class="font-weight-bold">BAPP</label>
												<p>
													<a :href="detailList.upload_bapp?.[0]?.file" target="_blank">{{
														detailList.upload_bapp?.[0]?.file ? 'File BAPP.pdf' : '-'
													}}</a>
												</p>
											</div>
										</div>
										<div class="col-lg-3" v-if="detailList.files && detailList.files.length > 0">
											<div class="form-group">
												<label class="font-weight-bold">Others</label>
												<p v-if="detailList.files">
													<a :href="detailList.files[0].file" target="_blank">{{
														detailList.files[0].file ? 'File Others.pdf' : '-'
													}}</a>
												</p>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="card" v-if="detailList.status === 'Closed'">
								<div class="card-header">
									<div class="card-header-title">Close Information</div>
								</div>
								<div class="card-body row">
									<div class="col-12 col-lg-3">
										<div class="form-group">
											<label class="font-weight-bold">Closed At</label>
											<p>{{ closedDate }}</p>
										</div>
									</div>
									<div class="col-12 col-lg-3">
										<div class="form-group">
											<label class="font-weight-bold">Closed By</label>
											<p>
												{{ detailList?.activity?.find((x) => x.status === 'Closed')?.user?.fullname || 'System' }}
											</p>
										</div>
									</div>
									<div class="col-12 col-lg-3">
										<div class="form-group">
											<label class="font-weight-bold">Closing Report</label>
											<p v-if="detailList.closing_report && detailList.closing_report.length > 0">
												<a :href="detailList.closing_report?.[0]?.file" target="_blank">{{
													detailList.closing_report?.[0]?.file ? 'File Closing Report.pdf' : '-'
												}}</a>
											</p>
											<p v-else>No file available</p>
										</div>
									</div>
									<div class="col-12 col-lg-3">
										<div class="form-group">
											<label class="font-weight-bold">BA Retention</label>
											<p v-if="detailList.ba_retention && detailList.ba_retention.length > 0">
												<a :href="detailList.ba_retention?.[0]?.file" target="_blank">File BA Retention.pdf</a>
											</p>
											<p v-else>No file available</p>
										</div>
									</div>
									<div class="col-12">
										<label class="font-weight-bold">Note</label>
										<p>
											{{ detailList?.activity?.find((x) => x.status === 'Closed')?.notes || '-' }}
										</p>
									</div>
								</div>
							</div>
							<div class="card" v-if="detailList.status === 'Early Termination'">
								<div class="card-header">
									<div class="card-header-title">Termination Information</div>
								</div>
								<div class="card-body row">
									<div class="col-12 col-lg-4">
										<div class="form-group">
											<label class="font-weight-bold">Terminated At</label>
											<p>{{ terminatedDate }}</p>
										</div>
									</div>
									<div class="col-12 col-lg-4">
										<div class="form-group">
											<label class="font-weight-bold">Terminated By</label>
											<p>
												{{ detailList?.activity?.find((x) => x.status === 'Early Termination')?.user?.fullname || '-' }}
											</p>
										</div>
									</div>
									<div class="col-12 col-lg-4">
										<div class="form-group">
											<label class="font-weight-bold">Evidence</label>
											<p v-if="detailList.upload_evidence && detailList.upload_evidence.length > 0">
												<a :href="detailList.upload_evidence?.[0]?.file" target="_blank">{{
													detailList.upload_evidence?.[0]?.file ? 'File Evidence.pdf' : '-'
												}}</a>
											</p>
											<p v-else>No file available</p>
										</div>
									</div>
									<div class="col-12">
										<label class="font-weight-bold">Note</label>
										<p>
											{{ detailList?.activity?.find((x) => x.status === 'Early Termination')?.notes || '-' }}
										</p>
									</div>
								</div>
							</div>
							<div class="card">
								<div class="card-header">
									<div class="card-header-title">Budget</div>
								</div>
								<div class="card-body p-0">
									<b-tabs fill>
										<b-tab title="List Budget GL">
											<vue-good-table
												:line-numbers="false"
												:columns="columnsBudgetGL"
												:rows="glData"
												:search-options="{ enabled: false }"
												:pagination-options="{
													enabled: true,
													perPage: 10,
													perPageDropdown: [10, 25, 50, 100],
													dropdownAllowAll: false,
												}"
												style-class="vgt-table table table-striped table-responsive table-sm"
											>
												<div slot="table-actions">
													<div class="d-flex" style="min-width: 400px; max-width: 400px">
														<v-select
															:options="yearsOptionPRPO"
															:reduce="(year) => year.value"
															label="label"
															name="Budget GL Year"
															placeholder="All Years"
															v-model="searchGLYear"
															@input="debouncedOnSearchGL"
														/>
														<input
															type="text"
															v-model="searchGL"
															class="form-control ml-2 mr-2"
															:style="{ width: '300px' }"
															placeholder="Search Budget GL"
															@input="debouncedOnSearchGL"
														/>
													</div>
												</div>
												<div slot="emptystate" class="text-center font-size-14">No data available</div>
												<!-- Custom Rows -->
											</vue-good-table>
										</b-tab>
										<b-tab title="List PR/PO">
											<vue-good-table
												:line-numbers="false"
												:columns="columnsPRPO"
												:rows="poData"
												:search-options="{ enabled: false }"
												:pagination-options="{
													enabled: true,
													perPage: 10,
													perPageDropdown: [10, 25, 50, 100],
													dropdownAllowAll: false,
												}"
												style-class="vgt-table table table-striped table-responsive table-sm"
											>
												<div slot="table-actions">
													<div class="d-flex">
														<div class="d-flex">
															<div class="mr-4 p-2">
																Total PO: <span class="font-weight-bold">{{ totalPo }}</span>
															</div>
															<div class="mr-4 p-2">
																Total DPP: <span class="font-weight-bold">{{ totalDpp }}</span>
															</div>
														</div>
														<div class="d-flex" style="min-width: 400px">
															<v-select
																:options="yearsOptionPRPO"
																:reduce="(year) => year.value"
																label="label"
																name="PR/PO Year"
																placeholder="All Years"
																v-model="searchPRPOYear"
																@input="debouncedOnSearchPO"
															/>
															<input
																type="text"
																v-model="searchPRPO"
																class="form-control ml-2 mr-2"
																:style="{ width: '300px' }"
																placeholder="Search PR/PO"
																@input="debouncedOnSearchPO"
															/>
														</div>
													</div>
												</div>
												<div slot="emptystate" class="text-center font-size-14">No data available</div>
												<!-- Custom Rows -->
												<template slot="table-row" slot-scope="props" class="overflow-x" style="overflow-x: auto">
													<span
														v-if="props.column.field == 'action'"
														@click="getListDetailPayment(props.row?.id, props.row?.budget_gl)"
														class="btn btn-sm btn-primary"
														>Detail Payment</span
													>
												</template>
											</vue-good-table>
										</b-tab>
									</b-tabs>
								</div>
							</div>
							<div class="card">
								<div class="card-header">
									<div class="card-header-title">List OA Number</div>
								</div>
								<div class="card-body p-0">
									<div class="table-responsive">
										<table class="table table-sm table-striped">
											<thead>
												<tr>
													<th scope="col" class="text-center">No</th>
													<th scope="col" class="text-center">OA Number</th>
												</tr>
											</thead>

											<template v-if="detailList && detailList.oa_number">
												<tbody>
													<tr
														v-for="(item, index) in Array.isArray(detailList.oa_number)
															? detailList.oa_number
															: detailList.oa_number !== undefined && detailList.oa_number !== null
															? [{ oa_number: detailList.oa_number }]
															: []"
														:key="index"
														class="border-t"
													>
														<td class="text-center">{{ item.no || index + 1 }}</td>
														<td class="text-center">{{ item.oa_number }}</td>
													</tr>
												</tbody>
											</template>

											<template v-else>
												<tbody>
													<tr>
														<td colspan="100" class="text-center">No Data Available</td>
													</tr>
												</tbody>
											</template>
										</table>
									</div>
								</div>
							</div>
							<div class="card">
								<div class="card-header">
									<div class="card-header-title">Contract Duration Detail</div>
								</div>
								<div class="card-body p-0">
									<b-tabs>
										<template v-if="detailList.contract_duration_detail.details.length > 0">
											<b-tab
												v-for="(item, index) in detailList.contract_duration_detail.details"
												:key="index"
												:title="item.detail_name"
											>
												<div class="table-responsive">
													<table class="table table-sm table-striped">
														<thead>
															<tr>
																<th scope="col">Item Name</th>
																<th scope="col">Work Duration</th>
																<th scope="col">Description</th>
															</tr>
														</thead>
														<tbody>
															<tr v-for="(data, indexx) in item.items" :key="indexx">
																<td class="description-cell" style="max-width: 450px">
																	<template v-if="data.item_name && data.item_name.length <= 100">
																		{{ data.item_name }}
																	</template>
																	<template v-else>
																		<div v-if="!expandedRows[indexx]">
																			{{ data.item_name.substring(0, 25) }}...
																			<button class="btn btn-sm btn-link p-0 ms-1" @click="toggleDescription(indexx)">Read More</button>
																		</div>
																		<div v-else>
																			{{ data.item_name }}
																			<button class="btn btn-sm btn-link p-0 ms-1" @click="toggleDescription(indexx)">Read Less</button>
																		</div>
																	</template>
																</td>
																<td>{{ data.work_duration }} Bulan</td>
																<!-- <td :id="'description' + indexx" class=" text-truncate d-inline-block" style="max-width: 500px;" :title="data.description">
                                  {{ data.description }}
                                </td>
                                <b-tooltip :target="'description' + indexx" placement="right" triggers="hover" variant="dark" boundary="'viewport'">
                                  {{ data.description }}
                                </b-tooltip> -->
																<td class="description-cell" style="max-width: 450px">
																	<template v-if="data.description && data.description.length <= 25">
																		{{ data.description }}
																	</template>
																	<template v-else>
																		<div v-if="!expandedRows[indexx]">
																			{{ data.description.substring(0, 25) }}...
																			<button class="btn btn-sm btn-link p-0 ms-1" @click="toggleDescription(indexx)">Read More</button>
																		</div>
																		<div v-else>
																			{{ data.description }}
																			<button class="btn btn-sm btn-link p-0 ms-1" @click="toggleDescription(indexx)">Read Less</button>
																		</div>
																	</template>
																</td>
															</tr>
														</tbody>
													</table>
												</div>
											</b-tab>
										</template>
										<template v-else>
											<div class="text-center p-4">
												<p>No Data Available</p>
											</div>
										</template>
									</b-tabs>
								</div>
							</div>
							<div class="card">
								<div class="card-header">
									<div class="card-header-title">Term of Payment</div>
								</div>
								<div class="card-body">
									<div class="card">
										<div class="card-header">
											<div class="card-header-title">Fixed Assigment</div>
										</div>
										<div class="card-body">
											<b-tabs>
												<b-tab
													v-for="(data, index) in detailList.term_of_payments.fixed_assignment.contract_items"
													:key="index"
													:title="data.contract_item"
												>
													<vsa-list style="max-width: 100% !important">
														<vsa-item v-for="(item, indexx) in data.terms" :key="indexx">
															<vsa-heading> Term {{ indexx + 1 }} </vsa-heading>

															<vsa-icon>
																<span class="isOpen fe fe-chevron-down"></span>
																<span class="isClose fe fe-chevron-up"></span>
															</vsa-icon>

															<vsa-content>
																<div class="row">
																	<div class="col-lg-3">
																		<div class="form-group">
																			<label class="font-weight-bold">Term</label>
																			<p>{{ item.term }}</p>
																		</div>
																	</div>
																	<div class="col-lg-3">
																		<div class="form-group">
																			<label class="font-weight-bold">Percentage</label>
																			<p>{{ item.percentage }}%</p>
																		</div>
																	</div>
																	<div class="col-lg-3">
																		<div class="form-group">
																			<label class="font-weight-bold">Amount</label>
																			<p>Rp. {{ item.amount }}</p>
																		</div>
																	</div>
																	<div class="col-lg-3">
																		<div class="form-group">
																			<label class="font-weight-bold">Description</label>
																			<p>{{ item.description }}</p>
																		</div>
																	</div>
																</div>
																<!-- <h4 class="font-weight-bold">Details</h4> -->
																<!-- <div class="row">
                                  <div v-for="(dts, detailIndex) in item.details" :key="detailIndex" class="col-lg-3">
                                    <div class="form-group">
                                      <label class="font-weight-bold">Detail {{ detailIndex + 1 }}</label>
                                      <p>{{ dts }}</p>
                                    </div>
                                  </div>
                                </div> -->
															</vsa-content>
														</vsa-item>
													</vsa-list>
												</b-tab>
											</b-tabs>
										</div>
									</div>
									<div class="card">
										<div class="card-header">
											<div class="card-header-title">Provision</div>
										</div>
										<div class="card-body">
											<b-tabs>
												<b-tab
													v-for="(data, index) in detailList.term_of_payments.provision.contract_items"
													:key="index"
													:title="data.contract_item"
												>
													<vsa-list style="max-width: 100% !important">
														<vsa-item v-for="(item, indexx) in data.terms" :key="indexx">
															<vsa-heading> Term {{ indexx + 1 }} </vsa-heading>

															<vsa-icon>
																<span class="isOpen fe fe-chevron-down"></span>
																<span class="isClose fe fe-chevron-up"></span>
															</vsa-icon>

															<vsa-content>
																<div class="row">
																	<div class="col-lg-3">
																		<div class="form-group">
																			<label class="font-weight-bold">Term</label>
																			<p>{{ item.term }}</p>
																		</div>
																	</div>
																	<div class="col-lg-3">
																		<div class="form-group">
																			<label class="font-weight-bold">Percentage</label>
																			<p>{{ item.percentage }}%</p>
																		</div>
																	</div>
																	<div class="col-lg-3">
																		<div class="form-group">
																			<label class="font-weight-bold">Amount</label>
																			<p>Rp. {{ item.amount }}</p>
																		</div>
																	</div>
																	<div class="col-lg-3">
																		<div class="form-group">
																			<label class="font-weight-bold">Description</label>
																			<p>{{ item.description }}</p>
																		</div>
																	</div>
																</div>
																<!-- <h4 class="font-weight-bold">Details</h4> -->
																<div class="row">
																	<div v-for="(dts, detailIndex) in item.details" :key="detailIndex" class="col-lg-3">
																		<div class="form-group">
																			<label class="font-weight-bold">Detail {{ detailIndex + 1 }}</label>
																			<p>{{ dts }}</p>
																		</div>
																	</div>
																</div>
															</vsa-content>
														</vsa-item>
													</vsa-list>
												</b-tab>
											</b-tabs>
										</div>
									</div>
								</div>
							</div>

							<!-- <table class="table table-bordered">
                <thead>
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">NAME</th>
                    <th scope="col">EMAIL</th>
                    <th scope="col">WHATSAPP NUMBER</th>
                    <th scope="col">STATUS</th>
                  </tr>
                </thead>
                <tbody></tbody>
              </table> -->
							<!-- <template>
                <div class="card">
                  <div class="card-header">
                    
                    <h2 class="card-header-title">Template</h2>
                    
                    <div
                      class="row align-items-center"
                      style="margin-top: -1.5rem"
                    >
                      
                      <ul class="nav nav-tabs nav-overflow header-tabs">
                        <li class="nav-item" @click="directTabs('Email')">
                          <a
                            class="nav-link"
                            :class="{ active: direct === 'Email' }"
                          >
                            Email
                          </a>
                        </li>
                        <li class="nav-item" @click="directTabs('WhatsApp')">
                          <a
                            class="nav-link"
                            :class="{ active: direct === 'WhatsApp' }"
                          >
                            WhatsApp
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div v-if="direct === 'Email'">
                    <div class="row">
                      //If self point >= 0 
                      <div class="col-12 col-lg-4 col-sm">
                        <div
                          class="card-body"
                          style="background-color: #a1a1a180"
                        >
                          <div
                            class="card-body"
                            style="background-color: white; border-radius: 10px"
                          >
                            <div
                              class="row align-items-center gx-0"
                              style="color: #a1a1a1"
                            >
                              <div class="col">
                                <h4>Email Variables:</h4>
                                <div class="col">
                                  <span class="ml-2"
                                    >- {titlename} : Title Name</span
                                  >
                                </div>
                                <div class="col mt-2">
                                  <span class="ml-2"
                                    >- {employeename} : Employee Name</span
                                  >
                                </div>
                                <div class="col mt-2">
                                  <span class="ml-2">- {date} : Date</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-lg-6 col-xl">
                        <div class="card-body">
                          <form @submit.prevent="saveAdd()">
                            <div class="form-group">
                              <label
                                >To <span class="text-danger">*</span></label
                              >
                              <v-select
                                v-model="modalCreate.to"
                                :options="['ASC', 'DESC']"
                                v-validate="'required'"
                                name="To"
                                multiple
                              />
                              <span
                                class="text-sm text-danger"
                                v-show="errors.has('To')"
                                >{{ errors.first("To") }}</span
                              >
                            </div>
                            <div class="form-group">
                              <label
                                >Title <span class="text-danger">*</span></label
                              >
                              <input
                                type="text"
                                v-model="modalCreate.title"
                                class="form-control"
                                placeholder="Title"
                                v-validate="'required'"
                                name="Title"
                              />
                              <span
                                class="text-sm text-danger"
                                v-show="errors.has('Title')"
                                >{{ errors.first("Title") }}</span
                              >
                            </div>
                            <div class="form-group">
                              <label
                                >Body <span class="text-danger">*</span></label
                              >
                              <vue-editor v-model="modalCreate.content" />
                            </div>
                            <div class="form-group">
                              <button
                                style="margin-left: auto; float: right"
                                class="mt-4 btn btn-outline-success"
                                type="submit"
                              >
                                <span class="fe fe-save"></span>
                                Send
                              </button>
                              <button
                                style="margin-right: auto; float: right"
                                class="mt-4 btn btn-primary mr-3"
                              >
                                <span class="fe fe-search"></span>
                                Preview
                              </button>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="direct === 'WhatsApp'">
                    <div class="card-body">
                      <form @submit.prevent="saveAdd()">
                        <div class="row">
                          //If self point >= 0
                          <div class="col-12 col-lg-6 col-xl">
                            <div class="form-group">
                              <label
                                >WhatsApp Number
                                <span class="text-danger">*</span></label
                              >
                              <v-select
                                v-model="modalCreate.to"
                                :options="['ASC', 'DESC']"
                                v-validate="'required'"
                                name="WhatsApp Number"
                                multiple
                              />
                              <span
                                class="text-sm text-danger"
                                v-show="errors.has('WhatsApp Number')"
                                >{{ errors.first("WhatsApp Number") }}</span
                              >
                            </div>
                          </div>
                          <div class="col-12 col-lg-6 col-xl">
                            <div class="form-group">
                              <label
                                >Attachment
                                <span class="text-danger">*</span></label
                              >
                              <input
                                type="file"
                                class="form-control"
                                v-validate="'required'"
                                name="Attachment"
                              />
                              <span
                                class="text-sm text-danger"
                                v-show="errors.has('Attachment')"
                                >{{ errors.first("Attachment") }}</span
                              >
                            </div>
                          </div>
                        </div>
                        <div class="form-group">
                          <label
                            >Message <span class="text-danger">*</span></label
                          >
                          <textarea
                            type="text"
                            v-model="modalCreate.title"
                            class="form-control"
                            placeholder="Message"
                            rows="5"
                          />
                        </div>
                        <div class="form-group">
                          <button
                            style="margin-left: auto; float: right"
                            class="mt-4 mb-3 btn btn-outline-success"
                            type="submit"
                          >
                            <span class="fe fe-save"></span>
                            Send
                          </button>
                          <button
                            style="margin-right: auto; float: right"
                            class="mt-4 mb-3 btn btn-primary mr-3"
                          >
                            <span class="fe fe-search"></span>
                            Preview
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </template> -->
						</div>
					</div>
				</div>
			</div>
			<b-modal id="modal-1" hide-footer :title="`${status} Form`" @hide="confirmCloseModal" @close="">
				<form @submit.prevent="saveContract()" v-if="status == 'Closed'">
					<div class="row">
						<div class="col-lg-6">
							<div class="form-group">
								<label>Closing Report (Pdf)<span class="text-danger">*</span></label>
								<input
									type="file"
									accept=".pdf"
									class="form-control"
									@change="setFileClosingReport"
									v-validate="'required|max:1000'"
									name="Closing Report File"
								/>
								<span class="text-sm text-danger" v-show="errors.has('Closing Report File')">{{
									errors.first('Closing Report File')
								}}</span>
								<small class="form-text text-muted">Maximum file size is 10 MB. Only PDF format is allowed.</small>
							</div>
						</div>
						<div class="col-lg-6">
							<div class="form-group">
								<label>BA Retetion (Pdf)<span class="text-danger">*</span></label>
								<input
									type="file"
									accept=".pdf"
									class="form-control"
									@change="setFileBaRetetion"
									v-validate="'required'"
									name="BA Retetion File"
								/>
								<span class="text-sm text-danger" v-show="errors.has('BA Retetion File')">{{
									errors.first('BA Retetion File')
								}}</span>
								<small class="form-text text-muted">Maximum file size is 10 MB. Only PDF format is allowed.</small>
							</div>
						</div>
					</div>
					<div class="form-group">
						<label>Notes <span class="text-danger">*</span></label>
						<textarea
							type="text"
							v-model="closeContractBody.notes"
							class="form-control"
							placeholder="Notes"
							v-validate="'required|max:1000'"
							name="Notes"
						/>
						<span class="text-sm text-danger" v-show="errors.has('Notes')">{{ errors.first('Notes') }}</span>
					</div>
					<div class="form-group">
						<button
							style="margin-left: auto; float: right"
							class="mt-4 btn btn-primary"
							type="button"
							@click="openConfirmModal"
							v-if="isLoading == false"
						>
							<!-- Save close -->
							Save
						</button>
						<button style="margin-left: auto; float: right" class="mt-4 btn btn-primary" type="button" disabled v-else>
							<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
							Loading...
						</button>
					</div>
				</form>
				<form @submit.prevent="saveContract()" v-else>
					<div class="row">
						<div class="col-lg-12">
							<div class="form-group">
								<label>Evidence (Pdf)<span class="text-danger">*</span></label>
								<input
									type="file"
									accept=".pdf"
									class="form-control"
									@change="setFileEvidence"
									v-validate="'required|max:1000'"
									name="Evidence File"
								/>
								<span class="text-sm text-danger" v-show="errors.has('Evidence File')">{{
									errors.first('Evidence File')
								}}</span>
								<small class="form-text text-muted">Maximum file size is 10 MB. Only PDF format is allowed.</small>
							</div>
						</div>
					</div>
					<div class="form-group">
						<label>Notes <span class="text-danger">*</span></label>
						<textarea
							type="text"
							v-model="earlyTerminateBody.notes"
							class="form-control"
							placeholder="Notes"
							v-validate="'required|max:1000'"
							name="Notes"
						/>
						<span class="text-sm text-danger" v-show="errors.has('Notes')">{{ errors.first('Notes') }}</span>
					</div>
					<div class="form-group">
						<button
							style="margin-left: auto; float: right"
							class="mt-4 btn btn-primary"
							type="button"
							@click="openConfirmModal"
							v-if="isLoading == false"
						>
							<!-- Save terminate -->
							Save
						</button>
						<button style="margin-left: auto; float: right" class="mt-4 btn btn-primary" type="button" disabled v-else>
							<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
							Loading...
						</button>
					</div>
				</form>
			</b-modal>

			<!-- Confirm Action  -->
			<b-modal id="confirm-modal" hide-footer title="Confirmation">
				<p>Are you sure you want to proceed with this action?</p>
				<div class="d-flex justify-content-end">
					<b-button variant="danger" @click="confirmAction">Yes, Proceed</b-button>
					<b-button variant="secondary" class="ml-2" @click="$bvModal.hide('confirm-modal')">Cancel</b-button>
				</div>
			</b-modal>

			<b-modal size="xl" id="modalBudgetItem" title="Detail" hide-footer>
				<div style="overflow: auto">
					<table class="table table-sm table-bordered table-nowrap" style="table-layout: fixed; word-wrap: break-word">
						<thead>
							<tr>
								<!-- <th style="width: 350px;" scope="col">Budget Task</th>
              <th style="width: 350px;" scope="col">Total Budget</th> -->

								<!-- <th style="width: 100px;" scope="col">Action</th> -->
								<th style="width: 270px" scope="col">BAST Number</th>
								<th style="width: 220px" scope="col">BAST Date</th>
								<th style="width: 270px" scope="col">SES/GR Number</th>
								<th style="width: 270px" scope="col">INV Number</th>
								<th style="width: 270px" scope="col">Vendor Name</th>
								<th style="width: 220px" scope="col">DPP</th>
								<th style="width: 220px" scope="col">VAT</th>
								<th style="width: 220px" scope="col">AFTER TAX</th>
								<th style="width: 220px" scope="col">WHT</th>
								<th style="width: 220px" scope="col">NET VALUE</th>
								<th style="width: 220px" scope="col">FA FORM DATE</th>
								<th style="width: 220px" scope="col">DOC TO FA DATE</th>
								<th style="width: 220px" scope="col">PAYMENT DATE</th>
							</tr>
						</thead>
						<tbody v-for="(item, indexx) in actualItem" :key="indexx">
							<tr>
								<td>{{ item.bast_subject }}</td>
								<td>
									{{ item.bast_date }}
								</td>
								<td>{{ item.ses_gr_number }}</td>
								<td>{{ item.inv_subject }}</td>
								<td>{{ item.vendor_name }}</td>
								<!-- <td>Rp. {{ convertNumber(item.dpp) }}</td>
                <td>Rp. {{ item ? convertNumber(item.vat) : 0 }}</td>
                <td>Rp. {{ item ? convertNumber(item.after_tax) : 0 }}</td>
                <td>Rp. {{ item ? convertNumber(item.wht) : 0 }}</td>
                <td>Rp. {{ item ? convertNumber(item.net_value) : 0 }}</td> -->
								<td>
									{{ item.fa_form }}
								</td>
								<td>
									{{ item.doc_to_fa }}
								</td>
								<td>
									{{ item.payment_date }}
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</b-modal>

			<!-- Modal Detail Payment -->
			<b-modal id="modal-detail-payment" hide-footer size="xl" :title="prNames ? `Detail Payment - ${prNames}` : ''">
				<!-- <div class="row">
					<div class="col-lg-3">
						<span>PR Name</span>
						<p>{{ detailList.po.data.pr_subject }}</p>
						<prev>{{detailList.po.data}}</prev>
					</div>
					<div class="col-lg-3">
						<span>PR Number</span>
						<p>{{ detailList.po.data[0].pr_subject }}</p>
					</div>
					<div class="col-lg-3">
						<span>PO Number</span>
						<p>{{ detailList.po.error_po_number[0] }}</p>
					</div>
					<div class="col-lg-3">
						<span>Contract Detail</span>
						<p>{{ detailList.po.data.contract_detail }}</p>
					</div>
				</div> -->
				<vue-good-table
					:line-numbers="false"
					:columns="columnsDetailPayment"
					:rows="detailPayment"
					:search-options="{ enabled: false }"
					:pagination-options="{ enabled: true, perPage: 10 }"
					style-class="vgt-table table table-bordered table-responsive"
				>
					<div slot="emptystate" class="text-center font-size-14">No data available</div>
					<template slot="table-row" slot-scope="props" class="overflow-x" style="overflow-x: auto">
						<span v-if="props.column.field == 'wht'"> Rp.{{ convertNumber(props.row.wht) }} </span>
						<span v-else-if="props.column.field == 'dpp'"> Rp.{{ convertNumber(props.row.dpp) }} </span>
						<span v-else-if="props.column.field == 'vat'"> Rp.{{ convertNumber(props.row.vat) }} </span>
						<span v-else-if="props.column.field == 'after_tax'"> Rp.{{ convertNumber(props.row.after_tax) }} </span>
						<span v-else-if="props.column.field == 'net_value'"> Rp.{{ convertNumber(props.row.net_value) }} </span>
					</template>
					<template slot="pagination-bottom">
						<div class="d-flex justify-content-end" style="width: auto">
							<b-pagination
								:value="1"
								:total-rows="1"
								:per-page="10"
								first-number
								last-number
								align="right"
								prev-class="prev-item"
								next-class="next-item"
								class="m-3"
								@input="(value) => props.pageChanged({ currentPage: value })"
							>
							</b-pagination>
						</div>
					</template>
				</vue-good-table>
			</b-modal>
		</div>
	</div>
</template>

<script>
	import list from '@/store/notification/list';
	import { indonesianCalendar, formatCurrency } from '@/utils/common';
	import Axios from 'axios';
	import moment from 'moment';
	import { VsaList, VsaItem, VsaHeading, VsaContent, VsaIcon } from 'vue-simple-accordion';
	import { props } from 'vue2-dropzone';
	import debounce from 'lodash/debounce';
	import { authorize } from '@/utils/authorize';
	// import 'vue-simple-accordion/dist/vue-simple-accordion.css';

	export default {
		name: 'DetailsContract',
		components: {
			VsaList,
			VsaItem,
			VsaHeading,
			VsaContent,
			VsaIcon,
		},
		computed: {
			detailList() {
				// console.log("detailList", this.$store.getters["listContract/detail"]);
				return this.$store.getters['listContract/detail'];
			},
			detailPayment() {
				return this.$store.getters['listContract/detailPayment'];
			},
			closedDate() {
				return indonesianCalendar(this.detailList?.activity?.find((x) => x.status === 'Closed')?.created_at, true) || '-';
			},
			terminatedDate() {
				return (
					indonesianCalendar(this.detailList?.activity?.find((x) => x.status === 'Early Termination')?.created_at, true) ||
					'-'
				);
			},
			startDate() {
				return indonesianCalendar(this.detailList.start_date) || '-';
			},
			endDate() {
				return indonesianCalendar(this.detailList.end_date) || '-';
			},
			createdAt() {
				return indonesianCalendar(this.detailList?.created_at) || '-';
			},
			createdBy() {
				return this.detailList?.user?.fullname || 'System';
			},
			updatedAt() {
				return indonesianCalendar(this.detailList.lastUpdate?.created_at) || '-';
			},
			updatedBy() {
				return this.detailList.lastUpdate?.user?.fullname || '-';
			},
			yearsOptionPRPO() {
				const yearsOptions = Object.keys(this.detailList.contractYears).map((year) => ({
					label: year,
					value: Number(year),
				}));
				console.log(yearsOptions);
				return yearsOptions;
			},
			totalPo() {
				let total = 0;
				this.poData.forEach((item) => {
					total += parseFloat(item.po_value);
				});
				return total > 0 ? formatCurrency(total, 'Rp. ') : 'Rp. 0';
			},
			totalDpp() {
				let total = 0;
				this.poData.forEach((item) => {
					total += parseFloat(item.total_dpp);
				});
				return total > 0 ? formatCurrency(total, 'Rp. ') : 'Rp. 0';
			},
			ownerDepartment() {
				return (
					(this.detailList?.owner?.department ||
						this.detailList?.owner?.divisi ||
						this.detailList?.owner?.departments?.[0]?.name) ??
					'Department not set'
				);
			},
			coOwnerDepartment() {
				return (
					(this.detailList?.co_owner?.department ||
						this.detailList?.co_owner?.divisi ||
						this.detailList?.co_owner?.departments?.[0]?.name) ??
					'Department not set'
				);
			},
		},
		data() {
			return {
				expandedRows: {},
				listDetailPayment: [],
				confirmedAction: false,
				direct: 'Email',
				dummyListPRPO: [
					{
						budget_gl: '123456',
						budget_task: 'Task A',
						pr_name: 'PR-001',
						pr_subject: 'Purchase Request for Project A',
						pr_date: '2023-01-15',
						po_number: 'PO-001',
						po_date: '2023-01-20',
						total_dpp: 5000000,
						contract_detail: 'Contract A Details',
					},
				],
				modalCreate: {
					to: '',
					title: '',
					content: '',
				},
				body: {},
				closeContractBody: {
					closingReport: '',
					ba_retetion: '',
					notes: '',
				},
				earlyTerminateBody: {
					evidence: '',
					notes: '',
				},
				actualItem: [],
				data: {
					no: '',
					name: '',
					typeContract: '',
					contract: '',
					budget: '',
					remaining_budget: '',
					files: [],
					vendor: '',
					start_date: '',
					end_date: '',
					scope_of_work: '',
					status: '',
					notes: '',
				},
				term_of_payments: [
					{
						term: '',
						percentage: '',
					},
				],
				prNames: null,
				columnsPRPO: [
					{
						label: 'Budget GL',
						field: 'budget_gl',
						thClass: 'table-header text-xs text-muted font-weight-bold',
						tdClass: 'text-sm color-secondary align-middle',
						width: '20%',
					},
					{
						label: 'Budget Task',
						field: 'budget_task',
						thClass: 'table-header text-sm text-muted font-weight-bold',
						tdClass: 'text-sm color-secondary align-middle',
						width: '10%',
					},
					{
						label: 'PR Number',
						field: 'pr_subject',
						thClass: 'table-header text-sm text-muted font-weight-bold',
						tdClass: 'text-sm color-secondary align-middle',
						width: '10%',
					},
					{
						label: 'PR  Date',
						field: 'pr_date',
						thClass: 'table-header text-sm text-muted font-weight-bold',
						tdClass: 'text-sm color-secondary align-middle',
						width: '10%',
					},
					{
						label: 'PO Number',
						field: 'po_subject',
						thClass: 'table-header text-sm text-muted font-weight-bold',
						tdClass: 'text-sm color-secondary align-middle',
						width: '10%',
					},
					{
						label: 'PO Date',
						field: 'po_date',
						thClass: 'table-header text-sm text-muted font-weight-bold',
						tdClass: 'text-sm color-secondary align-middle',
						width: '10%',
					},
					{
						label: 'PO Value',
						field: (field) => formatCurrency(field?.po_value, 'Rp.') || '-',
						thClass: 'table-header text-sm text-muted font-weight-bold',
						tdClass: 'text-sm color-secondary align-middle',
						width: '10%',
					},
					{
						label: 'Total DPP',
						field: (field) => formatCurrency(field?.total_dpp, 'Rp.') || '-',
						thClass: 'table-header text-sm text-muted font-weight-bold',
						tdClass: 'text-sm color-secondary align-middle',
						width: '10%',
					},
					{
						label: 'Action',
						field: 'action',
						thClass: 'table-header text-sm text-muted font-weight-bold',
						tdClass: 'text-sm color-secondary align-middle',
						sortable: false,
						searchable: false,
						width: '10%',
					},
				],
				columnsBudgetGL: [
					{
						label: 'Budget Plan',
						field: 'budget_plan_title',
						thClass: 'table-header text-xs text-muted font-weight-bold',
						tdClass: 'text-sm color-secondary align-middle',
						width: '20%',
					},
					{
						label: 'Budget GL',
						field: 'budget_gl',
						thClass: 'table-header text-xs text-muted font-weight-bold',
						tdClass: 'text-sm color-secondary align-middle',
						width: '20%',
					},
					{
						label: 'Budget Task',
						field: 'budget_task_name',
						thClass: 'table-header text-xs text-muted font-weight-bold',
						tdClass: 'text-sm color-secondary align-middle',
						width: '20%',
					},
					{
						label: 'Remaining Budget',
						field: (field) => formatCurrency(field?.remaining_budget, 'Rp.') || 'Rp. 0',
						thClass: 'table-header text-sm text-muted font-weight-bold',
						tdClass: 'text-sm color-secondary align-middle',
						width: '10%',
					},
				],
				columnsDetailPayment: [
					{
						label: 'BAST NUmber',
						field: 'bast_subject',
						width: '200px',
					},
					{
						label: 'BAST DATE',
						field: 'bast_date',
						width: '200px',
					},
					{
						label: 'SES GR NUMBER',
						field: 'ses_gr_no_subject',
						width: '200px',
					},
					{
						label: 'INV NUMBER',
						field: 'inv_subject',
						width: '200px',
					},
					{
						label: 'VENDOR NAME',
						field: 'vendor_name',
						width: '500px',
					},
					{
						label: 'DPP',
						field: 'dpp',
						width: '170px',
					},
					{
						label: 'VAT',
						field: 'vat',
						width: '170px',
					},
					{
						label: 'AFTER TAX',
						field: 'after_tax',
						width: '170px',
					},
					{
						label: 'WHT',
						field: 'wht',
						width: '170px',
					},
					{
						label: 'NET VALUE',
						field: 'net_value',
						width: '170px',
					},
				],
				notes: '',
				isLoading: false,
				id: '',
				status: '',
				fullname: '',
				searchPRPO: '',
				searchPRPOYear: '',
				poData: [],
				debouncedOnSearchPO: null,
				searchGL: '',
				searchGLYear: '',
				glData: [],
				debouncedOnSearchGL: null,
				canEdit: false,
			};
		},
		async mounted() {
			this.getList().then(() => {
				const defaultYear = moment().format('YYYY');
				this.searchPRPOYear = this.yearsOptionPRPO.find((x) => x.value == defaultYear)?.value;
				this.searchGLYear = this.yearsOptionPRPO.find((x) => x.value == defaultYear)?.value;
				this.searchPoData();
				this.searchGLData();
			});
			// const fullname = localStorage.getItem("fullname");
			// this.fullname = fullname;
			const params = this.$route.params.id;
			if (params === undefined) {
				this.$router.push({ name: 'ListContract' });
			}
			// this.id = this.$route.params.id;
			// this.data = this.detailList;
			// this.data.start_date = moment(this.detailList.start_date).format(
			//   "DD-MM-YYYY"
			// );
			// this.data.end_date = moment(this.detailList.end_date).format("DD-MM-YYYY");
			// this.term_of_payments = this.detailList.term_of_payments;
			this.canEdit = await authorize('/listContract', 'update');
		},
		created() {
			this.debouncedOnSearchPO = debounce(this.searchPoData, 500);
			this.debouncedOnSearchGL = debounce(this.searchGLData, 500);
		},
		methods: {
			toggleDescription(index) {
				this.$set(this.expandedRows, index, !this.expandedRows[index]);
			},
			resetDataCloseContract() {
				this.closeContractBody = {
					closingReport: '',
					ba_retetion: '',
					notes: '',
				};
			},
			resetDataEarlyTerminate() {
				this.earlyTerminateBody = {
					evidence: '',
					notes: '',
				};
			},
			confirmCloseModal(event) {
				if (event.trigger === 'backdrop') {
					event.preventDefault();
				}
				if (event.trigger === 'headerclose') {
					event.preventDefault();
					this.$swal({
						title: 'Confirm Close?',
						text: 'Are you sure want to close this modal?',
						icon: 'warning',
						showCancelButton: true,
						confirmButtonColor: '#00D97E',
						cancelButtonColor: '#E63757',
						confirmButtonText: 'Yes',
					}).then((result) => {
						if (result.isConfirmed) {
							this.$bvModal.hide('modal-1');
							this.resetDataCloseContract();
							this.resetDataEarlyTerminate();
						}
					});
				}
			},
			async getListDetailPayment(id, budget_gl) {
				this.prNames = budget_gl;
				await this.$store.dispatch('listContract/GET_LIST_DETAIL_PAYMENT', id);
				console.log('listDetailPayment', this.listDetailPayment);
				this.$bvModal.show('modal-detail-payment');
			},
			openConfirmModal() {
				this.$bvModal.show('confirm-modal');
			},
			confirmAction() {
				this.$bvModal.hide('confirm-modal');
				this.saveContract(); // Proceed to save after confirmation
			},
			directTabs(data) {
				if (data === 'Email') {
					this.direct = 'Email';
				} else if (data === 'WhatsApp') {
					this.direct = 'WhatsApp';
				}
			},
			bodyClosed(status) {
				this.$bvModal.show('modal-1');
				this.status = status;
			},

			async getList() {
				await this.$store.dispatch('listContract/GET_BY_ID', this.$route.params.id);
			},
			// async setFileClosingReport(event) {
			//   this.closeContractBody.closingReport = event.target.files;
			// },
			// async setFileBaRetetion(event) {
			//   this.closeContractBody.ba_retetion = event.target.files;
			// },
			async setFileClosingReport(event) {
				const file = event.target.files[0];
				if (file) {
					if (file.type !== 'application/pdf') {
						this.$swal('Error', 'Format file harus PDF.', 'error');
						event.target.value = ''; // Reset input file
						return;
					}
					if (file.size > 10 * 1024 * 1024) {
						// 10 MB
						this.$swal('Error', 'Ukuran file tidak boleh lebih dari 10 MB.', 'error');
						event.target.value = ''; // Reset input file
						return;
					}
					this.closeContractBody.closingReport = event.target.files;
				}
			},
			async setFileBaRetetion(event) {
				const file = event.target.files[0];
				if (file) {
					if (file.type !== 'application/pdf') {
						alert('Format file harus PDF.');
						event.target.value = ''; // Reset input file
						return;
					}
					if (file.size > 10 * 1024 * 1024) {
						// 10 MB
						this.$swal('Error', 'Ukuran file tidak boleh lebih dari 10 MB.', 'error');
						event.target.value = ''; // Reset input file
						return;
					}
					this.closeContractBody.ba_retetion = event.target.files;
				}
			},
			async setFileEvidence(event) {
				const file = event.target.files[0];
				if (file) {
					if (file.type !== 'application/pdf') {
						alert('Format file harus PDF.');
						event.target.value = ''; // Reset input file
						return;
					}
					if (file.size > 10 * 1024 * 1024) {
						// 10 MB
						alert('Ukuran file tidak boleh lebih dari 10 MB.');
						event.target.value = ''; // Reset input file
						return;
					}
					this.earlyTerminateBody.evidence = event.target.files;
				}
			},

			saveContract() {
				this.$validator.validateAll().then(async (res) => {
					if (!res) return false;
					try {
						this.isLoading = true;
						let data = {};
						if (this.status == 'Closed') {
							const formData = new FormData();
							formData.append('status', this.status);
							formData.append('notes', this.closeContractBody.notes);
							for (let file of this.closeContractBody.closingReport) {
								formData.append('files_closing_report', file);
							}
							for (let file of this.closeContractBody.ba_retetion) {
								formData.append('files_ba_retention', file);
							}
							data = {
								id: this.detailList.id,
								form: formData,
							};
							console.log('data', data);
						} else {
							const formData = new FormData();
							formData.append('status', this.status);
							formData.append('notes', this.earlyTerminateBody.notes);
							for (let file of this.earlyTerminateBody.evidence) {
								formData.append('files_upload_evidence', file);
							}
							data = {
								id: this.detailList.id,
								form: formData,
							};
						}
						this.$store
							.dispatch('listContract/CHANGE_STATUS', data)
							.then((resp) => {
								this.$swal('Saved', 'Your input has been saved', 'success').then((resp) => {
									this.isLoading = false;
									this.notes = '';
									this.$bvModal.hide('modal-1');
									this.$router.push({
										name: 'ListContract',
										params: { data: this.status === 'Closed' ? 'closed' : 'earlyTermination' },
									});
								});
							})
							.catch((err) => {
								this.isLoading = false;
								this.$swal('Error', err.response.data.error, 'error');
							});
					} catch (error) {
						this.$swal('Error', 'Error while add data', 'error');
					}
				});
			},

			downloadItem(url) {
				// this.$store.dispatch("listContract/downloadFile", url);
				const a = document.createElement('a');
				a.href = url;
				a.target = '_blank';
				a.setAttribute('download', this.detailList?.name + '.pdf');
				document.body.appendChild(a);
				a.click();
				document.body.removeChild(a);
			},

			convertNumber(dat) {
				if (dat) {
					return dat.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',');
				} else if (dat === 0) {
					return 0;
				} else {
					return '';
				}
			},

			downloadData(id, name) {
				let body = {
					id: id,
					filename: name,
				};
				this.$store.dispatch('listContract/downloadID', body);
			},
			// convertNumber(dat) {
			//   if (dat === undefined) {
			//     console.log("data is undefined");
			//     return "";
			//   }
			//   console.log("data=>>", dat);
			//   return dat.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
			// },
			newItem(data) {
				this.actualItem = data;
				setTimeout(() => {
					this.$bvModal.show('modalBudgetItem');
				}, 500);
			},
			searchPoData() {
				console.log('search PR/PO', { year: this.searchPRPOYear, search: this.searchPRPO });
				const unfilteredPoData = this.detailList?.list_pr_po?.data || [];
				let filteredData = [];
				//filter by years first
				if (this.searchPRPOYear) {
					const result = unfilteredPoData.filter((item) => {
						return item.pr_date.substring(0, 4) == this.searchPRPOYear;
					});
					filteredData = result;
				} else {
					filteredData = unfilteredPoData;
				}
				// search on filtered years to math the search
				if (this.searchPRPO) {
					const result = filteredData.filter((item) => {
						return Object.values(item).some((value) => {
							const valueAsString = String(value).toLowerCase();
							const searchTermLower = String(this.searchPRPO).toLowerCase();

							return valueAsString.includes(searchTermLower);
						});
					});
					filteredData = result;
				}
				this.poData = filteredData;
			},

			searchGLData() {
				console.log('search GL', { year: this.searchGLYear, search: this.searchGL });
				const unfilteredGLData = this.detailList?.list_budget_gl || [];
				let filteredData = [];
				//filter by years first
				if (this.searchGLYear) {
					const result = unfilteredGLData.filter((item) => {
						return item.budget_plan_year == this.searchGLYear;
					});
					filteredData = result;
				} else {
					filteredData = unfilteredGLData;
				}
				// search on filtered years to math the search
				if (this.searchGL) {
					const result = filteredData.filter((item) => {
						return Object.values(item).some((value) => {
							const valueAsString = String(value).toLowerCase();
							const searchTermLower = String(this.searchGL).toLowerCase();

							return valueAsString.includes(searchTermLower);
						});
					});
					filteredData = result;
				}
				this.glData = filteredData;
			},

			getStatusClass(status) {
				if (status === 'On Going') {
					return 'badge bg-green align-items-center badge-lg';
				} else if (status === 'Closed') {
					return 'badge bg-red align-items-center badge-lg';
				} else if (status === 'Early Termination') {
					return 'badge bg-dark align-items-center badge-lg';
				} else if (status === 'Expired Soon') {
					return 'badge bg-yellow align-items-center badge-lg';
				} else if (status === 'Expired') {
					return 'badge bg-pink align-items-center badge-lg';
				} else if (status === 'Value Warning') {
					return 'badge bg-orange align-items-center badge-lg';
				} else if (status === 'Draft') {
					return 'badge bg-gray align-items-center badge-lg';
				}
			},
		},
	};
</script>
<style>
	.vsa-item__heading {
		width: 100%;
		height: 100%;
	}

	.vsa-item__heading,
	.vsa-item__trigger {
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}

	.vsa-item__trigger {
		margin: 0;
		padding: 0;
		color: inherit;
		font-family: inherit;
		font-size: 16px;
		line-height: 1.15;
		border-width: 0;
		background-color: transparent;
		background-image: none;
		overflow: visible;
		text-transform: none;
		flex: 1 1 auto;
		color: var(--vsa-text-color);
		transition: all 0.2s linear;
		padding: var(--vsa-heading-padding);
	}

	.vsa-item__trigger[role='button'] {
		cursor: pointer;
	}

	.vsa-item__trigger[type='button'],
	.vsa-item__trigger[type='reset'],
	.vsa-item__trigger[type='submit'] {
		-webkit-appearance: button;
	}

	.vsa-item__trigger:focus {
		outline: 1px dotted;
		outline: 5px auto -webkit-focus-ring-color;
	}

	.vsa-item__trigger::-moz-focus-inner,
	.vsa-item__trigger[type='button']::-moz-focus-inner,
	.vsa-item__trigger[type='reset']::-moz-focus-inner,
	.vsa-item__trigger[type='submit']::-moz-focus-inner {
		border-style: none;
		padding: 0;
	}

	.vsa-item__trigger:-moz-focusring,
	.vsa-item__trigger[type='button']:-moz-focusring,
	.vsa-item__trigger[type='reset']:-moz-focusring,
	.vsa-item__trigger[type='submit']:-moz-focusring {
		outline: 1px dotted ButtonText;
	}

	.vsa-item__trigger:focus,
	.vsa-item__trigger:hover {
		outline: none;
		background-color: var(--vsa-highlight-color);
		color: var(--vsa-bg-color);
	}

	.vsa-item__trigger__icon--is-default {
		width: 40px;
		height: 40px;
		transform: scale(var(--vsa-default-icon-size));
	}

	.vsa-item__trigger__icon--is-default:after,
	.vsa-item__trigger__icon--is-default:before {
		background-color: var(--vsa-text-color);
		content: '';
		height: 3px;
		position: absolute;
		top: 10px;
		transition: all 0.13333s ease-in-out;
		width: 30px;
	}

	.vsa-item__trigger__icon--is-default:before {
		left: 0;
		transform: rotate(45deg) translate3d(8px, 22px, 0);
		transform-origin: 100%;
	}

	.vsa-item__trigger__icon--is-default:after {
		transform: rotate(-45deg) translate3d(-8px, 22px, 0);
		right: 0;
		transform-origin: 0;
	}

	.vsa-item__trigger[aria-expanded='true'] .vsa-item__trigger__icon--is-default:before {
		transform: rotate(45deg) translate3d(14px, 14px, 0);
	}

	.vsa-item__trigger[aria-expanded='true'] .vsa-item__trigger__icon--is-default:after {
		transform: rotate(-45deg) translate3d(-14px, 14px, 0);
	}

	.vsa-item__trigger__icon {
		display: block;
		margin-left: auto;
		position: relative;
		transition: all 0.2s ease-in-out;
	}

	.vsa-item__trigger:focus .vsa-item__trigger__icon--is-default:after,
	.vsa-item__trigger:focus .vsa-item__trigger__icon--is-default:before,
	.vsa-item__trigger:hover .vsa-item__trigger__icon--is-default:after,
	.vsa-item__trigger:hover .vsa-item__trigger__icon--is-default:before {
		background-color: var(--vsa-bg-color);
	}

	.vsa-item__trigger__content {
		font-weight: 700;
		font-size: 14px !important;
	}

	.vsa-item__content {
		margin: 0;
		padding: 20px 20px;
	}

	.vsa-item--is-active .vsa-item__heading,
	.vsa-item:not(:last-of-type) {
		border-bottom: var(--vsa-border);
	}

	.vsa-collapse-enter-active,
	.vsa-collapse-leave-active {
		transition-property: opacity, height, padding-top, padding-bottom;
		transition-duration: 0.3s;
		transition-timing-function: ease-in-out;
	}

	.vsa-collapse-enter,
	.vsa-collapse-leave-active {
		opacity: 0;
		height: 0;
		padding-top: 0;
		padding-bottom: 0;
		overflow: hidden;
	}

	.vsa-list {
		--vsa-max-width: 720px;
		--vsa-min-width: 300px;
		--vsa-heading-padding: 10px 10px;
		--vsa-text-color: #373737;
		--vsa-highlight-color: #a12529;
		--vsa-bg-color: #fff;
		--vsa-border-color: rgba(0, 0, 0, 0.2);
		--vsa-border-width: 1px;
		--vsa-border-style: solid;
		--vsa-border: var(--vsa-border-width) var(--vsa-border-style) var(--vsa-border-color);
		--vsa-content-padding: 1rem 1rem;
		--vsa-default-icon-size: 1;
		display: block;
		max-width: var(--vsa-max-width);
		min-width: var(--vsa-min-width);
		width: 100%;
		padding: 0;
		margin: 0;
		list-style: none;
		border: var(--vsa-border);
		color: var(--vsa-text-color);
		background-color: var(--vsa-bg-color);
	}

	.vsa-list [hidden] {
		display: none;
	}
	.vgt-inner-wrap {
		min-width: 100% !important;
	}
	.text-sm {
		font-size: 0.9125rem !important;
	}
	.text-xs {
		font-size: 0.75rem !important;
	}
	.v-select {
		width: 100% !important;
	}
	.badge-lg {
		padding: 0.5rem 0.8rem !important;
		margin-bottom: 0px !important;
	}
	.badge.bg-green {
		background-color: #2ecc71;
	}

	.badge.bg-red {
		background-color: #ff0000;
	}

	.badge.bg-pink {
		background-color: #fd9596;
	}

	.badge.bg-dark {
		background-color: #333333;
	}

	.badge.bg-yellow {
		background-color: #f1c40f;
	}

	.badge.bg-orange {
		background-color: #e67e22;
	}

	.badge.bg-gray {
		background-color: #999999;
	}
</style>
<style lang="scss" scoped>
	.vsa-item {
		&--is-active {
			.vsa-item__trigger__icon {
				.isOpen {
					display: none;
				}

				.isClose {
					display: block;
				}
			}
		}

		&__trigger__icon {
			.isOpen {
				display: block;
			}

			.isClose {
				display: none;
			}
		}
	}
</style>
